import { BaseRepository } from './base.repository';
import { CreateEmpresaDto, EmpresaResponse } from '../services/types';

/**
 * Repository para operações relacionadas a empresas
 */
export class EmpresasRepository extends BaseRepository {
  /**
   * Cria uma nova empresa na landing page
   * Esta é a única rota pública - não requer token
   */
  async create(empresaData: CreateEmpresaDto): Promise<EmpresaResponse> {
    const response = await this.post<EmpresaResponse>(
      '/empresas',
      empresaData,
      {
        headers: {
          'X-Origin': typeof window !== 'undefined' ? window.location.origin : 'scheduling-frontend',
        },
      }
    );

    // Token is now handled via HttpOnly cookie
    return response;
  }


}

